import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'
import { Card } from '@/components/ui/card'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'

const ROWS = 5

const SnagsListSkeleton: React.FC = () => {
  return (
    <Card className="shadow-sm border-0">
      <div className="py-2 flex items-center gap-3 flex-wrap">
        <Skeleton className="h-7 w-10" />
        <Skeleton className="h-4 w-12" />
        <div className="flex items-center gap-2.5">
          <Skeleton className="h-3 w-8" />
          <Skeleton className="h-3 w-8" />
          <Skeleton className="h-3 w-8" />
        </div>
        <div className="flex-1 min-w-0">
          <Skeleton className="h-8 w-full max-w-md" />
        </div>
        <Skeleton className="h-8 w-24" />
        <Skeleton className="h-8 w-28" />
      </div>

      <div className="rounded-md border border-border overflow-hidden bg-card">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="!w-9 !p-0" />
              <TableHead><Skeleton className="h-3 w-8" /></TableHead>
              <TableHead><Skeleton className="h-3 w-14" /></TableHead>
              <TableHead><Skeleton className="h-3 w-16" /></TableHead>
              <TableHead><Skeleton className="h-3 w-12" /></TableHead>
              <TableHead><Skeleton className="h-3 w-24" /></TableHead>
              <TableHead><Skeleton className="h-3 w-20" /></TableHead>
              <TableHead><Skeleton className="h-3 w-20" /></TableHead>
              <TableHead><Skeleton className="h-3 w-16" /></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {Array.from({ length: ROWS }).map((_, i) => (
              <TableRow key={i}>
                <TableCell className="!w-9 !p-0 text-center">
                  <Skeleton className="h-4 w-4 mx-auto" />
                </TableCell>
                <TableCell><Skeleton className="h-4 w-10" /></TableCell>
                <TableCell><Skeleton className="h-5 w-16 rounded-full" /></TableCell>
                <TableCell><Skeleton className="h-5 w-16 rounded-full" /></TableCell>
                <TableCell><Skeleton className="h-4 w-40" /></TableCell>
                <TableCell><Skeleton className="h-4 w-28" /></TableCell>
                <TableCell><Skeleton className="h-4 w-24" /></TableCell>
                <TableCell><Skeleton className="h-4 w-20" /></TableCell>
                <TableCell><Skeleton className="h-4 w-20" /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      <div className="flex items-center justify-between py-3 px-1">
        <Skeleton className="h-4 w-36" />
        <div className="flex gap-1">
          <Skeleton className="h-8 w-8" />
          <Skeleton className="h-8 w-8" />
          <Skeleton className="h-8 w-8" />
        </div>
      </div>
    </Card>
  )
}

export default SnagsListSkeleton
